import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBMaximumEarningsSetup } from "../../components/WSIBMaximumEarningsSetup";

export const WSIBMaximumEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Maximum Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Maximum Earnings Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBMaximumEarningsSetup />}
    />
  );
};
